import './App.css';

import Home from './Components/Home';
import Skills from './Components/Skills';
import Projects from './Components/Projects';
import Connect from './Components/Connect';
import Contact from './Components/Contact';

function App() {
  return (
    <div className='App'>
      <Home />
      <Skills />
      <Projects />
      <Connect />
      <Contact />
    </div>
  );
}

export default App;
